import { createListenerMiddleware, createSlice, isAnyOf } from '@reduxjs/toolkit';
import { readStorageValue, removeStorageValue, saveStorageValue } from 'hooks/use-storage/use-storage.utils';
import { RootState } from 'store/root.types';

export const importedEventingFunctionSliceName = 'importedEventingFunction';

type ImportedEventingFunction = {
  eventingFunction: string;
};

export const getInitialState = () => {
  const eventingFunction = readStorageValue<ImportedEventingFunction>({
    storageKey: importedEventingFunctionSliceName,
    fallbackValue: { eventingFunction: '' },
  });

  return eventingFunction;
};

export const importedEventingFunctionSlice = createSlice({
  name: importedEventingFunctionSliceName,
  initialState: getInitialState(),
  reducers: {
    setImportedEventingFunction(state, action) {
      state.eventingFunction = action.payload;
    },
    reset(state) {
      removeStorageValue(importedEventingFunctionSliceName);
      Object.assign(state, getInitialState());
    },
  },
});

export const { setImportedEventingFunction } = importedEventingFunctionSlice.actions;
export const { reset } = importedEventingFunctionSlice.actions;

export const importedEventingFunction = (state: RootState) => {
  return state[importedEventingFunctionSliceName].eventingFunction;
};

export const importedEventingFunctionListenerMiddleware = createListenerMiddleware();

importedEventingFunctionListenerMiddleware.startListening({
  matcher: isAnyOf(setImportedEventingFunction),
  effect: (action, listenerApi) => {
    saveStorageValue({
      storageKey: importedEventingFunctionSliceName,
      value: (listenerApi.getState() as RootState)[importedEventingFunctionSliceName],
    });
  },
});
